import api from "../../core/api";
import { Page } from "../../shared/models/models";
import { ChangeUser, User, UsersQuery } from "../models/AdminUsersModels";

class AdminUsersApi {
  getUsers(query: UsersQuery): Promise<Page<User>> {
    return api.get<Page<User>>(`/v1/admin/users`, { params: query }).then(x => x.data);
  }

  changeUser(id: string, user: ChangeUser): Promise<any> {
    return api.put(`/v1/admin/users/${id}`, user);
  }

  changeUserStatus(id: string, isDisabled: boolean): Promise<any> {
    return api.put(`/v1/admin/users/${id}/status`, { isDisabled });
  }

  deleteUser(id: string): Promise<any> {
    return api.delete(`/v1/admin/users/${id}`);
  }
}

export default new AdminUsersApi();